/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TCreateMessageModel = IModel<ICreateMessageRequest, TCreateMessageResponse>;

export interface ICreateMessageRequest {
  /** Комментарий **/
  comment?: string | null;
  /** Название компании (если профиль публичный) **/
  companyName?: string | null;
  /** Код подтверждения телефона **/
  confirmationCode?: string | null;
  /** E-mail **/
  email: string;
  /** ФИО **/
  fullName: string;
  /** Является ли пользователь профессионалом (у него есть профиль агента) **/
  hasAgentProfile?: boolean | null;
  /** Заявку подает собственник **/
  isHomeowner?: boolean | null;
  /** поисковый запрос JsonQuery **/
  jsonQuery: any;
  /** Телефон **/
  phone: string;
  /** Приоритетный тип связи **/
  priorityCommunicationChannel?: EPriorityCommunicationChannel | null;
  /** Источник заявки **/
  source?: string | null;
}

export type TCreateMessageResponse = ICreateMessageResponse200 | ICreateMessageResponse400;

export interface ICreateMessageResponse200 extends IModelResponse<ICreateMessageResponse> {
  statusCode: 200;
}

export interface ICreateMessageResponse400 extends IModelResponse<ICreateMessageResponseError> {
  statusCode: 400;
}

export interface ICreateMessageResponse {
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: number | null;
  /** ID заявки **/
  id: number;
  /** Статус ответа **/
  status: EStatus;
}

export interface ICreateMessageResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICreateMessageResponse | ICreateMessageResponseError;

export enum EStatus {
  /** Не правильный код подтверждения **/
  CodeError = 'codeError',
  /** Дубликат **/
  Duplicate = 'duplicate',
  /** Необходимо подтверждение номера телефона **/
  NeedPhoneConfirm = 'needPhoneConfirm',
  /** Успешно **/
  Ok = 'ok',
}

export enum EPriorityCommunicationChannel {
  /** Email **/
  Email = 'email',
  /** Телефон **/
  Phone = 'phone',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICreateMessageResponse): TResponse200;
  400(response: ICreateMessageResponseError): TResponse400;
}
